/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/templates/QaTemplateInsertedSummary.tsx
 * FILE_ID: QA-TEMPLATES-SUMMARY-001
 * PURPOSE: Confirmation after a template insert, then back to Build.
 */
import type { QaTemplatePicker } from './useQaTemplatePicker'

export function QaTemplateInsertedSummary({
  picker,
  onClose,
  onAgain,
}: {
  picker: QaTemplatePicker
  onClose: () => void
  onAgain: () => void
}) {
  const counts = picker.result?.counts
  const created = picker.result?.created ?? []
  const byArea = new Map<string, string[]>()
  for (const row of created) {
    const key = row.area || 'area'
    const list = byArea.get(key) ?? []
    if (row.template_name) list.push(row.template_name)
    byArea.set(key, list)
  }
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto p-3" data-testid="qa-templates-inserted">
      <p className="text-sm font-medium">
        {counts?.checklists ?? 0} checklists - {counts?.items ?? 0} steps added to {counts?.areas ?? 0} areas
      </p>
      <div className="grid gap-3 md:grid-cols-2">
        {[...byArea.entries()].map(([areaId, names]) => (
          <div key={areaId}>
            <ul className="list-disc pl-4 text-sm">
              {names.slice(0, 6).map((name) => <li key={name}>{name}</li>)}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-auto flex flex-wrap gap-2">
        <button
          type="button"
          onClick={onAgain}
          className="rounded-md border border-border px-3 py-1.5 text-xs font-medium"
        >
          Open templates again
        </button>
        <button
          type="button"
          onClick={onClose}
          className="rounded-md bg-foreground px-3 py-1.5 text-xs font-medium text-background"
        >
          Back to Build
        </button>
      </div>
    </div>
  )
}
